module.exports = __webpack_public_path__ + "img/lilbosh_meil_yes.b4dcef56.png";